import { createSelector } from '@ngrx/store';
import { getDotCmsState } from '../dot-cms-store';

export const getDotCmsNavigationState = createSelector(getDotCmsState, state => state.navigation);
export const getDotCmsHeaderNavigationItem = createSelector(
  getDotCmsNavigationState,
  navigation => navigation.headerNavigation
);
